<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap");

.search-form-retailers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  align-content: start;
  position: relative;
  top: 100px;
  margin-top: 94px;
}

.search-form-retailers .top-title {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.search-form-retailers .top-title h1 {
  font-size: 64px;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.02em;
  font-family: "Montserrat";
  color: #3d4053;
}

.search-form-retailers .top-title h2 {
  font-size: 24px;
  font-weight: 100;
  line-height: 100%;
  letter-spacing: -0.02em;
  font-family: "Montserrat";
  color: #3d4053;
  margin-top: 30px;
}

.search-form-retailers .questioner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
}

.search-form-retailers .questioner .form-input {
  width: 100%;
  text-align: center;
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
  height: 100px;
}

.form-input .select-location {
  margin-top: 30px;
  margin-bottom: 30px;
}

.search-form-retailers .questioner .form-input input {
  width: 70%;
  height: 70px;
  border: none;
  border-bottom: 2px solid #57f3bb;
  font-size: 30px;
  text-align: left;
  font-family: "Montserrat";
  font-weight: 400;
  padding-right: 15px;
  padding-left: 15px;
}

.search-form-retailers .questioner .form-input input:focus {
  outline: none;
  color: #c5c5c5;
  font-weight: 400;
  font-family: "Montserrat";
  font-size: 20px;
  bottom: 30px;
}

.search-form-retailers .questioner .form-input input::placeholder {
  outline: none;
  color: #c5c5c5;
  font-weight: 400;
  font-family: "Montserrat";
  font-size: 20px;
}

.form-error {
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  width: 100%;
  margin-bottom: 50px;
}

.search-form-submit {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  margin-bottom: 100px;
}

.search-form-submit .submit-btn {
  color: #fff;
  background: linear-gradient(267.53deg, #ff3ca5 0%, #ca74ff 100%);
  height: 60px;
  border: none;
  border-radius: 17px;
  width: 286px;
  font-size: 33px;
  font-weight: 600;
  font-family: "Montserrat";
  cursor: pointer;
  text-transform: uppercase;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.0196802), 
  0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0282725), 
  0px 22.3363px 17.869px rgba(0, 0, 0, 0.035), 
  0px 12.5216px 10.0172px rgba(0, 0, 0, 0.0417275), 
  0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0503198), 
  0px 2.76726px 2.21381px rgba(0, 0, 0, 0.07);
}

.type-title {
  line-height: 52px;
  font-size: 24px;
  text-align: left;
  font-weight: 600;
  margin-right: 20px;
  /* color: #fff; */
  font-family: "Montserrat";
  width: 100%;
}

#step1 .type-title {
  /* width: 60%; */
}

.select-followers {
  .multiselect__element {
    padding: 20px;

    > span {
      border-radius: 10px;

      &:hover {
   
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .search-form-retailers .top-title h1 {
    font-size: 30px;
  }

  .search-form-retailers .top-title h2 {
    font-size: 30px;
  }
  .search-form-retailers .questioner {
    width: 100%;
    flex-direction: column;
    margin-bottom: 50px;
    margin-top: 50px;
  }

  #step1 .type-title {
    width: 80%;
    font-size: 20px;
  }
  /* .type-title {
    width: 80%;
    font-size: 20px;
    margin-bottom: 30px;
  } */

  .search-form-retailers .questioner .form-input {
    justify-content: center;
    flex-direction: column;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .search-form-retailers .questioner .form-input input {
    width: 100%;
    font-size: 14px;
  }
  .form-input input:focus {
    bottom: 30px;
  }
}
</style>

<template>
  <div class="container">
    <MainMenu />
    <div class="search-form-retailers">
      <div class="top-title">
        <h1>Hello {{ user.retailers.fullname }}</h1>
        <h2>Let us help you.</h2>
      </div>

      <div class="questioner">
        <div class="form-input" id="step1">
          <h3 class="type-title">What are you looking for:</h3>

          <Multiselect
            v-model="user.retailers.followers"
            tag-placeholder=""
            class="select-followers"
            placeholder="Nano, Micro, Macro Influencers"
            :options="followers"
            :multiple="true"
            :max="1"
            track-by="title"
            label="title"
            :taggable="true"
            autocomplete="name"
            @select="selectedFollowers"
            @remove="removeFollowers"
            required
          ></Multiselect>
        </div>

        <div v-if="showCat" class="form-input select-location">
          <h3 class="type-title" text="">My Target Audience Is:</h3>

          <Multiselect
            v-model="user.retailers.category"
            tag-placeholder="category"
            placeholder="Mothers, Kids, Fitness Gurus, Dieticians, Geeks"
            :options="user.categories"
            :multiple="true"
            :max="1"
            :taggable="true"
            autocomplete="name"
            @select="selectedCat"
            @remove="removeCat"
            @tag="addCat"
            required
          ></Multiselect>
        </div>
        <div v-if="showCountry" class="form-input select-country">
          <h3 class="type-title">{{ typemachine }}</h3>

          <Multiselect
            v-model="user.retailers.location"
            tag-placeholder="category"
            placeholder="United States,Canda,Germany"
            :options="countries"
            :multiple="true"
            :max="1"
            :taggable="true"
            autocomplete="name"
            @select="selectedCountry"
            @remove="removeCountry"
            required
          ></Multiselect>
        </div>
      </div>

      <div v-if="showSearch" class="search-form-submit">
        <button class="submit-btn" @click="submitForm()">Search Now</button>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router.js";
import { mapState, mapActions } from "vuex";

import MainMenu from "../components/MainMenu";
import { VueTyper } from "vue-typer";
import { Multiselect } from "vue-multiselect";

export default {
  name: "RetailersSearch",
  data() {
    return {
      typemachine: "That Will Locate and\nReach My Customers In",
      showCat: false,
      showCountry: false,
      showSearch: false,
      followers: [
        {
          min: 0,
          max: 10000,
          title: "Nano Influencers",
          info: "< 10k followers",
        },
        {
          min: 10000,
          max: 100000,
          title: "Micro Influencers",
          info: "10k-100k followers",
        },
        {
          min: 100000,
          max: 1000000,
          title: "Macro Influencers",
          info: "100k-1m followers",
        },
      ],
      countries: [
        "Worldwide",
        "United States",
        "United Kingdom",
        "Germany",
        "Australia",
        "Canada",
        "France",
        "Afghanistan",
        "Aland Islands",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory",
        "British Virgin Islands",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",

        "Cape Verde",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo",
        "Congo - Democratic Republic of",
        "Cook Islands",
        "Costa Rica",
        "Cote d'Ivoire",
        "Croatia",
        "Cuba",
        "Curacao",
        "Cyprus",
        "Czechia",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands (Islas Malvinas)",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories",
        "Gabon",
        "Gambia",
        "Georgia",

        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (Vatican City State)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia - Federated States of",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "North Korea",
        "North Macedonia",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Barthelemy",
        "Saint Helena",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Korea",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",

        "United States Minor Outlying Islands",
        "United States Virgin Islands",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Wallis and Futuna",
        "West Bank",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
      ],
      categories: [
        "Tourism",
        "Kids",
        "Real Estate",
        "Parties",
        "Music",
        "Babies",
        "Media",
        "Entertainment",
        "Fashion Modeling",
        "Spirituality",
        "Luxury",
        "TV",
        "Cinema",
        "Humanities",
        "Pets",
        "Parenting",
        "Social Media",
        "Tattoos",
        "Leisure",
        "Technology",
        "Marketing",
        "Vegan",
        "LGBT",
        "Basketball",
        "Surfing",
        "Motorcycles",
        "Toys",
        "Motivation",
        "Nutrition",
        "Photography",
        "Digital Marketing",
        "Bodybuilding",
        "Crossfit",
        "Dance",
        "Nature",
        "Home Decor and Improvement",
        "Event Planning",
        "Cars",
        "Clothes and Accessories",
        "Catering",
        "Bars and Restaurants",
        "Wellness and Nature",
        "Food Photography",
        "Mommy",
        "Design",
        "Running",
        "Racing",
        "Internet",
        "Drinks",
        "Gaming",
        "Beauty and Cosmetics",
        "Comedy",
        "Lifestyle",
        "Cooking",
        "Beauty Blogger",
        "Modeling",
        "Fitness",
        "Blogging",
        "Acting",
        "Fashion Blogger",
        "Art",
        "Fashion",
        "Fitness Models",
        "Hotels",
        "Performing Arts",
        "Handmade",
        "Food Blogger",
        "Public Relations",
        "Health",
        "Travel",
        "Writing",
        "Food",
        "Science",
        "Business and Economy",
        "Yoga",
        "Comics",
        "Entrepreneur",
        "Education",
        "Wedding",
        "Radio",
        "Sports",
        "Soccer",
      ],
    };
  },
  mounted() {
    this.$store.dispatch("getCategoriesList");
  },
  components: {
    MainMenu,
    VueTyper,
    Multiselect,
  },
  computed: mapState(["user"]),

  methods: {
    selectedFollowers: function (followers) {
      console.log(followers);
      this.user.retailers.max = followers.max;
      this.user.retailers.min = followers.min;
      this.user.retailers.followers_title = followers.title;

      this.showCat = true;
    },
    removeFollowers: function (followers) {
      console.log("remove followers--- ", followers);
      this.showCat = false;
      this.showCountry = false;
    },
    selectedCat: function (cat) {
      console.log("selected cat--- ", cat);
      this.user.retailers.keyword = cat;
      this.showCountry = true;
    },
    removeCat: function (cat) {
      console.log("remove cat--- ", cat);
      this.showCountry = false;
    },
    addCat: function (cat) {
      if (cat) {
        this.user.retailers.category = cat;
        this.user.retailers.keyword = cat;
        this.showCountry = true;
      }
    },
    selectedCountry: function (country) {
      console.log("selected country--- ", country);
      if (country === "Worldwide") {
        this.user.retailers.country = "";
      } else {
        this.user.retailers.country = country;
      }
      this.showSearch = true;
    },
    removeCountry: function (country) {
      console.log("remove country--- ", country);
      this.showSearch = false;
    },
    gtag_report_conversion(url) {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-10944536239/sMNvCP2Ky4sYEK-94eIo",
        event_callback: callback
      });
      return false;
    },
    submitForm: function () {
      this.gtag_report_conversion();
      router.push({ name: "RetailersResults" });
    },
  },
};
</script>
